import React from 'react';
import Seat from '../Seat';
import { useSelector } from 'react-redux';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  seatsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    overflowX: 'scroll',
    msOverflowX: 'scroll',
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: 2,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(104,97,88,1)',
      // outline: "1px solid slategrey",
    },
    '&:hover': {
      '&::-webkit-scrollbar': {
        width: 4,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
    },
  },
  nameSeat: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#D7DBDD',
  },
  name: {
    textAlign: 'start',
    textTransform: 'capitalize',
    width: 70,
    textOverflow: 'ellipsis',
  },
}));

function SeatsDisplay({
  setShowSeats,
  seatsArr,
  boxMovingSeatAssign,
  setSeatsArr,
}) {
  const classes = useStyles();
  const streamInfo = useSelector((state) => state.streamInfo);
  const movingBox = useSelector((state) => state.movingBox);

  const x = movingBox.newBoxID === streamInfo.defaultSeatBox.boxId;
  const y = streamInfo.defaultSeatBox.seatName;

  const handleSeatClick = (seat, selected) => {
    if (selected) {
      boxMovingSeatAssign(seat);
      setShowSeats(false);
      setSeatsArr([]);
    } else {
      return;
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(30, 22, 22, 0.6)',
        borderWidth: 1,
        borderStyle: 'dotted',
        borderColor: 'indigo',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        onClick={() => {
          setShowSeats(false);
          setSeatsArr([]);
          return null;
        }}
        style={{
          alignSelf: 'flex-end',
          cursor: 'pointer',
          zIndex: 1,
          fontWeight: 800,
        }}
      >
        <CancelSharpIcon color="error" />
      </div>
      <div className={classes.seatsContainer}>
        {seatsArr.map((seat) => {
          return (
            <div className={classes.nameSeat} key={seat.seatName}>
              <Seat
                key={seat.seatName}
                seat={seat}
                handleSeatClick={handleSeatClick}
                pageFrom = 'layout'
                sameBoxSeat={x ? y === seat.seatName : false}
              />
              {/* <Typography variant="caption" noWrap className={classes.name}>
                {seat.firstName || '(empty)'}
              </Typography> */}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SeatsDisplay;
